import { createSelector } from "reselect"
import { capitalize } from "lodash"
import { getViewType, getPortfolioName } from "modules/portfolio-root/selectors/portfolios"
import { getDisplayTypeName } from "./items"
import { computeFileName } from "helpers/analyze"
import { getFactorSensitivityType } from "selectors/factorSensitivity"

const getStartDate = (_, props) => props.startDate
const getEndDate = (_, props) => props.endDate

export const getScreenName = createSelector(
  [getFactorSensitivityType],
  (factorSensitivityType) => `${capitalize(factorSensitivityType)} Factor Sensitivity`,
)

export const getFileName = createSelector(
  [getPortfolioName, getDisplayTypeName, getViewType, getScreenName, getStartDate, getEndDate],
  computeFileName,
)
